module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-box-wrap"
  }, [_c('ul', {
    staticClass: "head"
  }, [_c('li', {
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 0
      }
    }
  }, [_vm._v("增岗申请" + _vm._s(("(" + (_vm.add.total) + ")")))]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.activeIndex = 1
      }
    }
  }, [_vm._v("调岗申请" + _vm._s(("(" + (_vm.mod.total) + ")")))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    staticClass: "tab-div"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.changeType('add')
      }
    },
    model: {
      value: (_vm.add.status),
      callback: function($$v) {
        _vm.$set(_vm.add, "status", $$v)
      },
      expression: "add.status"
    }
  }, _vm._l((_vm.apply.statusOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("申请时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.add.date_start),
      callback: function($$v) {
        _vm.$set(_vm.add, "date_start", $$v)
      },
      expression: "add.date_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.add.date_end),
      callback: function($$v) {
        _vm.$set(_vm.add, "date_end", $$v)
      },
      expression: "add.date_end"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.addSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("申请时间\n\t\t\t\t\t\t"), _c('div', {
    staticClass: "angle-wrap"
  }, [_c('i', {
    staticClass: "el-icon-caret-top",
    class: {
      active: _vm.add.sort_str == 'createdAt_asc'
    },
    on: {
      "click": function () {
        _vm.add.sort_str = 'createdAt_asc';
        _vm.addSearch()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    class: {
      active: _vm.add.sort_str == 'createdAt_desc'
    },
    on: {
      "click": function () {
        _vm.add.sort_str = 'createdAt_desc';
        _vm.addSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("申请BU")]), _vm._v(" "), _c('div', [_vm._v("岗位名称")]), _vm._v(" "), _c('div', [_vm._v("增岗类型")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add.status != '1'),
      expression: "add.status !='1'"
    }]
  }, [_vm._v("审核人")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add.status != '1'),
      expression: "add.status !='1'"
    }]
  }, [_vm._v("审核时间")]), _vm._v(" "), _c('div', [_vm._v("状态")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-detail"
  }, [_vm._l((_vm.addList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.bu_name
      }
    }, [_vm._v(_vm._s(item.bu_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.position_name
      }
    }, [_vm._v(_vm._s(item.position_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.apply.postType[item.req_type]))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.add.status != '1'),
        expression: "add.status !='1'"
      }],
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.add.status != '1'),
        expression: "add.status !='1'"
      }]
    }, [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('div', {
      class: {
        danger: item.status == 1
      }
    }, [_vm._v(_vm._s(_vm.apply.statusObj[item.status]))]), _vm._v(" "), _c('div', {
      class: {
        'orange-text': item.status == 1
      },
      on: {
        "click": function($event) {
          _vm.showSlider(item, 'new')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("applyStatus")(item.status)))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.addList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.add.data
    },
    on: {
      "getPage": _vm.addSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    staticClass: "tab-div"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.changeType('mod')
      }
    },
    model: {
      value: (_vm.mod.status),
      callback: function($$v) {
        _vm.$set(_vm.mod, "status", $$v)
      },
      expression: "mod.status"
    }
  }, _vm._l((_vm.apply.statusOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("申请时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.mod.date_start),
      callback: function($$v) {
        _vm.$set(_vm.mod, "date_start", $$v)
      },
      expression: "mod.date_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.mod.date_end),
      callback: function($$v) {
        _vm.$set(_vm.mod, "date_end", $$v)
      },
      expression: "mod.date_end"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.modSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("申请时间\n\t\t\t\t\t\t"), _c('div', {
    staticClass: "angle-wrap"
  }, [_c('i', {
    staticClass: "el-icon-caret-top",
    class: {
      active: _vm.mod.sort_str == 'createdAt_asc'
    },
    on: {
      "click": function () {
        _vm.mod.sort_str = 'createdAt_asc';
        _vm.modSearch()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    class: {
      active: _vm.mod.sort_str == 'createdAt_desc'
    },
    on: {
      "click": function () {
        _vm.mod.sort_str = 'createdAt_desc';
        _vm.modSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("申请BU")]), _vm._v(" "), _c('div', [_vm._v("调岗人员")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mod.status != '1'),
      expression: "mod.status!='1'"
    }]
  }, [_vm._v("审核人")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mod.status != '1'),
      expression: "mod.status!='1'"
    }]
  }, [_vm._v("审核时间")]), _vm._v(" "), _c('div', [_vm._v("状态")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-detail"
  }, [_vm._l((_vm.modList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.bu_name
      }
    }, [_vm._v(_vm._s(item.bu_name))]), _vm._v(" "), _c('div', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(item.tran_names || "-"))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mod.status != '1'),
        expression: "mod.status!='1'"
      }],
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mod.status != '1'),
        expression: "mod.status!='1'"
      }]
    }, [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('div', {
      class: {
        danger: item.status == 1
      }
    }, [_vm._v(_vm._s(_vm.apply.statusObj[item.status]))]), _vm._v(" "), _c('div', {
      class: {
        'orange-text': item.status == 1
      },
      on: {
        "click": function($event) {
          _vm.showSlider(item, 'trans')
        }
      }
    }, [_vm._v(_vm._s(_vm._f("applyStatus")(item.status)))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.modList
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.mod.data
    },
    on: {
      "getPage": _vm.modSearch
    }
  })], 1)]), _vm._v(" "), _c('sliderPage', {
    attrs: {
      "title": _vm.slider_title,
      "sliderArg": _vm.sliderArg
    },
    on: {
      "close": _vm.sliderClear
    }
  }, [(_vm.activeIndex == 0) ? _c('sliderAdd', {
    attrs: {
      "sliderArg": _vm.sliderArg,
      "data": _vm.slider_data,
      "examine": _vm.sub
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? _c('sliderMod', {
    attrs: {
      "sliderArg": _vm.sliderArg,
      "data": _vm.slider_data,
      "examine": _vm.sub
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-tip",
    attrs: {
      "slot": "pass"
    },
    slot: "pass"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("是否确认提交处理结果")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sliderArg.insideFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmAdd(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmMod(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-tip",
    attrs: {
      "slot": "notpass"
    },
    slot: "notpass"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("是否确认提交处理结果")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sliderArg.insideFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.refuseAdd(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1),
      expression: "activeIndex == 1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.refuseMod(_vm.slider_data.id)
      }
    }
  }, [_vm._v("确定")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-43add9e9!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/examine/page-personnel-examine.vue
// module id = 734
// module chunks = 1